import script from "./selectionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./selectionCard.vue?vue&type=script&setup=true&lang=js"

import "./selectionCard.vue?vue&type=style&index=0&id=63ffce5a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/悦库.Site-ScoreQuery-Release/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ffce5a"]])

export default __exports__